import React from 'react';
import App from '../components/App';
import { headData } from '../mock/data';
import SEOHelmet from '../components/Seo/SeoHelmet';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../style/main.scss';

// export default () => {
//   const { title, lang, description } = headData;

//   return (
//     <>
//       <Helmet>
//         <link
//           rel="icon"
//           href="data:image/svg+xml,<svg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%2210 0 100 100%22><text y=%22.90em%22 font-size=%2290%22>✌undefined</text></svg>"
//         />
//         <meta charSet="utf-8" />
//         <title>{title || 'AB | Full Stack Developer'}</title>
//         <html lang={lang || 'en'} />
//         <meta name="description" content={description || 'Project Portfolio'} />
//       </Helmet>
//       <App />
//     </>
//   );
// };

export default () => {
  const { title, lang, description, imageUrl, pageUrl } = headData;

  return (
    <>
      <SEOHelmet
        title={title || 'Agata Boeckmann || Full-Stack Developer'}
        description={description || 'Welcome to my project portfolio!'}
        imageUrl={imageUrl || 'https://i.imgur.com/VFtAh6d.png'}
        pageUrl={pageUrl || 'https://shcoobz.github.io'}
        lang={lang || 'en'}
      />
      <App />
    </>
  );
};
